import { query } from '../utilities';

export const orderRepeat = (products) => {
    return query('/order/repeat/', {
        data: {
            products: JSON.stringify(products)
        }
    });
};
